module.exports = __webpack_public_path__ + "static/img/check.b11e1392.svg";